import { render, staticRenderFns } from "./DetailsModel.vue?vue&type=template&id=2b7c3ab7&scoped=true"
import script from "./DetailsModel.vue?vue&type=script&lang=js"
export * from "./DetailsModel.vue?vue&type=script&lang=js"
import style0 from "./DetailsModel.vue?vue&type=style&index=0&id=2b7c3ab7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7c3ab7",
  null
  
)

export default component.exports